// extracted by mini-css-extract-plugin
export var productImage = "_s3-1";
export var viewLink = "_s3-2";
export var wishlistItem = "_s3-0";